<template>
  <van-popup
    v-model="__show"
    :position="position"
    :close-on-click-overlay="closeOnClickOverlay"
    @close="closeHandler"
  >
    <div class="bottom-toast-inner">
      <div class="toast-title">
        {{ title }}
        <div class="close-btn" v-if="closeable" @click="closeHandler"></div>
      </div>
      <div class="section">
        <slot></slot>
      </div>
    </div>
  </van-popup>
</template>

<script>
export default {
  name: 'popupComponent',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    closeable: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    'close-on-click-overlay': {
      type: Boolean,
      default: true
    }
  },
  computed: {
    __show: {
      get() {
        return this.value
      },
      set(v) {
        this.$emit('input', v)
      }
    }
  },
  methods: {
    closeHandler() {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="less" scoped>
.bottom-toast-inner {
  background: #fff;
}

.toast-title {
  width: 100%;
  margin: 0 auto;
  font-weight: bold;
  color: #343437;
  font-size: 32rpx;
  line-height: 48rpx;
  padding: 32rpx 20rpx;
  position: relative;
  box-sizing: border-box;
  // &:after {
  //   position: absolute;
  //   bottom: 0;
  //   height: 1px;
  //   left: 24rpx;
  //   right: 24rpx;
  //   z-index: 10;
  //   display: inline-block;
  //   content: '';
  //   border-bottom: 1rpx solid rgba(235, 235, 235, 1);
  // }
}

.section {
  padding: 0 20rpx 68rpx 20rpx;
}

.close-btn {
  position: absolute;
  right: 20rpx;
  top: 24rpx;
  width: 60rpx;
  height: 60rpx;
  //background: url(https://static-image.tripurx.com/sys/app_icon/v4/common/close-icon-gray.png)
  background: url(https://image.todreamer.com/sys/app_icon/v4/common/close-icon-gray.png)
    no-repeat center center;
  background-size: 48rpx;
}
</style>
